import { render } from "./MDiscountEligible.vue?vue&type=template&id=226d5384&scoped=true&ts=true"
import script from "./MDiscountEligible.vue?vue&type=script&lang=ts"
export * from "./MDiscountEligible.vue?vue&type=script&lang=ts"

import "./MDiscountEligible.vue?vue&type=style&index=0&id=226d5384&lang=scss"
import "./MDiscountEligible.vue?vue&type=style&index=1&id=226d5384&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/campaign-widget/campaign-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-226d5384"]])

export default __exports__